import { render, staticRenderFns } from "./Ruleta.vue?vue&type=template&id=18e7fa9c&scoped=true&"
import script from "./Ruleta.vue?vue&type=script&lang=js&"
export * from "./Ruleta.vue?vue&type=script&lang=js&"
import style0 from "./Ruleta.vue?vue&type=style&index=0&id=18e7fa9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e7fa9c",
  null
  
)

export default component.exports